import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import Notifier, { openSnackbar } from './notifier';
import moment from 'moment';
import api from '../api/backend';

const styles = theme => ({
    root: {
        paddingTop: 50
    },
    media: {
        height: 140,
    },
});

class CovertEditor extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = { file: {}, time: moment().format() }
    }

    uploadCover = (file) => {
        const { courseId } = this.props
        api.uploadCover(courseId, file).then(([response, json]) => {
            if (response.status === 200) {
                console.log(json)
                this.setState({ time: moment().format() })
                openSnackbar({ message: 'อับโหลด cover สำเร็จ' })
            } else {
                console.error('อับโหลด cover ไม่สำเร็จ')
                openSnackbar({ message: 'อับโหลด cover ไม่สำเร็จ' })
            }
        }).catch(() => {
            console.error('ไม่สามารถเชื่อมต่อ service ได้')
            openSnackbar({ message: 'ไม่สามารถเชื่อมต่อ service ได้' })
        })
    }

    render() {
        const { classes, courseId } = this.props
        const { time } = this.state
        return (
            <div className={classes.root}>
                <Notifier />
                <Card className={classes.card} fullWidth>
                    <CardMedia
                        className={classes.media}
                        image={`${process.env.REACT_APP_BAKEND}/api/courses/cover/${courseId}?time=${time}`}
                        title="Contemplative Reptile"
                    />
                    <CardActions>
                        <input
                            accept="image/jpeg"
                            style={{ display: 'none' }}
                            id="contained-button-file"
                            multiple
                            type="file"
                            onChange={(event) => {
                                this.uploadCover(event.target.files[0])
                            }}
                        />
                        <label htmlFor="contained-button-file">
                            <Button color="primary" variant="contained" component="span" fullWidth>
                                อับโหลดรูป cover
                        </Button>
                        </label>
                    </CardActions>
                </Card>
            </div>
        );
    }
}

export default withStyles(styles)(CovertEditor);